import React from 'react';
import { useFormContext } from './Provider';
import { useModalContext } from '../Modal/Provider';
import { captureException } from '../../Services/Sentry';

const Inner = ({children, onSubmit, layout}) => {

    const {formData, setFormData, isValid, setIsValidating, setIsSubmitting, closeModalOnSubmit, goBackOnSubmit, afterSubmit, afterError, resetOnSubmit, resetForm} = useFormContext();
    const modalContext = useModalContext();

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isValid !== true) {
            setIsValidating(true);
            return;
        }

        setIsSubmitting(true);
        try {
            await onSubmit(formData);

            let updatedByAfterSubmit = false;
            if (afterSubmit) {
                const updatedData = afterSubmit(formData);
                if (updatedData) {
                    setFormData(updatedData);
                    updatedByAfterSubmit = true;
                }
            }
            if (!updatedByAfterSubmit && resetOnSubmit) {
                resetForm();
            }
            closeModalOnSubmit && modalContext?.closeModal();
            goBackOnSubmit && window.history.back();
        } catch (e) {
            setIsSubmitting(false);
            afterError && afterError(e);
            console.error(e);
            captureException(e);
        }
        setIsSubmitting(false);
    }

    const layoutClasses = {
        'horizontal': 'flex flex-row justify-between items-center',
        'vertical': 'flex flex-col gap-y-3'
    };

    return <form onSubmit={handleSubmit}>
        <div className={layoutClasses[layout]}>
            {children}
        </div>
    </form>
};

export default Inner;
